module.exports = __webpack_public_path__ + "img/bg_w.ceeff81c.png";